import { render, staticRenderFns } from "./saveJobCounseling.vue?vue&type=template&id=550ec7c3&"
import script from "./saveJobCounseling.vue?vue&type=script&lang=js&"
export * from "./saveJobCounseling.vue?vue&type=script&lang=js&"
import style0 from "./saveJobCounseling.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports